import { render, staticRenderFns } from "./HistoryDetailItemDetailLayout.vue?vue&type=template&id=26921756&scoped=true&"
import script from "./HistoryDetailItemDetailLayout.vue?vue&type=script&lang=js&"
export * from "./HistoryDetailItemDetailLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26921756",
  null
  
)

export default component.exports